<!--
 * @Author: Shber
 * @Date: 2022-03-17 16:49:23
 * @LastEditors: Shber
 * @LastEditTime: 2023-06-14 18:00:57
 * @Description:
-->
<template>
  <div>
    <div v-if="isReadonly" class="top_content auth_status">
      <template v-if="isAuthStatus === '1'">
        <svg class="icon icon_fail" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="36" cy="36" r="30" fill="#C99700" />
          <circle cx="36" cy="36" r="30" fill="#C99700" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M49.607 29.1672C50.1739 29.734 50.1739 30.6532 49.607 31.22L33.8625 46.9644C33.5889 47.238 33.2173 47.3911 32.8303 47.3895C32.4433 47.388 32.0729 47.232 31.8015 46.9561L23.4074 38.4267C22.8451 37.8553 22.8525 36.9362 23.4239 36.3739C23.9953 35.8115 24.9144 35.8189 25.4767 36.3903L32.8443 43.8768L47.5541 29.1671C48.121 28.6003 49.0401 28.6003 49.607 29.1672Z" fill="white" />
        </svg>

        <h3 class="fw_bold">{{ $t('auth.home.authSuccess') }}</h3>
        <p>{{ $t('auth.aiAuth.statusTip4') }}</p>
      </template>

      <template v-else-if="isAuthStatus === '3' || isAuthStatus === '4'">
        <svg class="icon icon_fail" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="36" cy="36" r="30" fill="#FA4338" />
          <circle cx="36" cy="36" r="30" fill="#FA4338" />
          <path d="M45.4381 27.6667C46.0049 27.0998 46.0049 26.1807 45.4381 25.6138C44.8712 25.0469 43.9521 25.0469 43.3852 25.6138L35.516 33.483L27.6468 25.6138C27.0799 25.0469 26.1608 25.0469 25.5939 25.6138C25.027 26.1807 25.027 27.0998 25.5939 27.6667L33.4631 35.5359L25.5934 43.4055C25.0266 43.9724 25.0266 44.8915 25.5934 45.4584C26.1603 46.0253 27.0794 46.0253 27.6463 45.4584L35.516 37.5888L43.3856 45.4584C43.9525 46.0253 44.8716 46.0253 45.4385 45.4584C46.0054 44.8915 46.0054 43.9724 45.4385 43.4055L37.5689 35.5359L45.4381 27.6667Z" fill="white" />
        </svg>

        <h3 class="fw_bold">{{ $t('auth.home.authFail') }}</h3>
        <p>{{ isTextType }}</p>
      </template>
      <template v-else>
        <svg class="icon icon_fail" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="36" cy="36" r="30" fill="#1ED760" />
          <circle cx="36" cy="36" r="30" fill="#1ED760" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M36 22.9355C36.8017 22.9355 37.4516 23.5854 37.4516 24.3871V38.4536L46.6953 47.5458C47.2668 48.108 47.2744 49.0271 46.7123 49.5986C46.1501 50.1702 45.231 50.1778 44.6594 49.6156L34.982 40.0968C34.7046 39.8239 34.5483 39.4511 34.5483 39.0619V24.3871C34.5483 23.5854 35.1982 22.9355 36 22.9355Z" fill="white" />
        </svg>

        <h3 class="fw_bold">{{ $t('auth.home.authWait') }}</h3>
        <p>{{ $t('auth.nameAuth.statusTip1') }}</p>
      </template>
    </div>
    <p v-else class="auth_tip">*{{ $t('auth.aiAuth.statusTip8') }}</p>
  </div>
</template>
<script setup>
import { defineProps, computed } from 'vue'
import { useI18n } from 'vue-i18n/index'// 要在js中使用国际化
const { t } = useI18n() // 国际化方法

const props = defineProps({
  authStatus: { // 认证状态
    type: String,
    default: ''
  },
  textType: { // 文案展示类型
    type: String,
    default: ''
  },
  readonly: {
    type: Boolean,
    default: true
  }
})

const isAuthStatus = computed(() => props.authStatus) // 认证状态
const isReadonly = computed(() => props.readonly) // 是否只读
const isTextType = computed(() => { // 报错文案展示
  switch (props.textType) {
    case '1':
      return t('auth.aiAuth.statusTip3')
    case '2':
      return t('auth.nameAuth.statusTip2')
    default: return t('auth.nameAuth.statusTip2')
  }
})

</script>
<style lang="scss">
.filed_line{
  .van-field{
    &::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    transform: scaleY(0.5);
    }
  }
}
.auth_tip{
  background: #F5F5F5;
}
</style>
